module.exports = __webpack_public_path__ + "static/66gde-30ea5ea2a20e430a4dc38cebd3cb5907.gif";